export const SET_ALL_STATUS = 'SET_ALL_STATUS';

export const setAllStatusLeads = (status) => ({
  type: SET_ALL_STATUS,
  payload: status,
});

